export const SUCCESSFULLY_CRAWLED = 'Successfully imported the URL';
export const SUCCESSFULLY_SYNCED = 'Successfully synced the URL';